import { Api } from '@shared/constants/common-field.constants';
import { IPlatformApiProvider } from '@shared/services/platform-api-provider';

export class ItrceFxrateApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/orbitax-connect/itrce/fxrates/')) {
      return Api.FxRate;
    }

    return '';
  }

}